export default "__VITE_ASSET__ClatYRbr__"